import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Projects", href: "/projects" },
    { name: "Downloads", href: "/downloads" },
    { name: "Contact", href: "/contact" },
  ];

  return (
    <header
      id="masthead"
      className={`fixed top-0 left-0 w-full z-[1000] transition-all duration-300 ${
        isScrolled ? "bg-black/90 shadow-md" : "bg-transparent"
      }`}
    >
      {/* Top Bar - Only visible if not scrolled or according to original design */}
      <div 
        className={`w-full border-b border-white/10 ${isScrolled ? 'hidden' : 'block'}`}
        style={{ backgroundColor: "transparent" }}
      >
        <div className="container mx-auto px-4 py-2 flex justify-end">
          <div className="text-[13px] text-white/80 font-body flex items-center space-x-1">
            <span>info@basupraexim.com | exportsbei@yahoo.com | +91-9890527244</span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-[80px]">
          {/* Logo / Site Title */}
          <div className="flex-shrink-0">
            <Link 
              to="/" 
              className="text-[24px] font-bold tracking-tight text-white font-display"
              style={{ fontWeight: 700 }}
            >
              BASUPRA EXIM
            </Link>
          </div>

          {/* Desktop Navigation Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <nav className="flex items-center space-x-7">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-[15px] font-medium text-white hover:text-secondary transition-colors font-display"
                >
                  {link.name}
                </Link>
              ))}
            </nav>

            {/* CTA Button */}
              <div className="ml-4">
                <a
                  href="/downloads/General-Catalogue.pdf"
                  download
                  className="inline-block px-6 py-3 bg-[#17A2B8] text-white text-[14px] font-semibold uppercase tracking-wider rounded-[2px] transition-all duration-200 hover:bg-[#138496] active:transform active:scale-95 font-display"
                >
                  Download Catalogue
                </a>
              </div>
          </div>

          {/* Mobile Menu Trigger (Visual Only for UI cloning) */}
          <button className="lg:hidden text-white p-2">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
